
<main role="main" class="flex-shrink-0">
<div class="container-fluid mt-5 mb-4">

<div class="row pb-2">
  <div class="col">
      <div class="alert alert-warning" role="alert">
          <h4 class="alert-heading pb-2"><i class="fas fa-ban"></i> Access Denied</h4>
      </div>
  </div>
</div>
</div>
</main>